/**
 * The `anchorScroll` utility saves the scroll position relative to an element,
 * and then restores it after a callback has been run.
 *
 * This is useful if a redraw will change the page's content above the viewport.
 * Normally doing this will result in the content in the viewport being pushed
 * down or pulled up. By wrapping the redraw with this utility, the scroll
 * position can be anchor to an element that is in or below the viewport, so
 * the content in the viewport will stay the same.
 *
 * @param {string | HTMLElement | SVGElement | Element} element The element to anchor the scroll position to.
 * @param {() => void} callback The callback to run that will change page content.
 */
export default function anchorScroll(element, callback) {
  const $window = $(window);
  const before = $(element).offset();

  // Nothing on the page to hold in place: a post stream the reader has
  // already left, for instance. The callback still has to run.
  if (!before) {
    callback();
    return;
  }
  const relativeScroll = before.top - $window.scrollTop();
  callback();
  const after = $(element).offset();
  if (after) {
    $window.scrollTop(after.top - relativeScroll);
  }
}
flarum.reg.add('core', 'common/utils/anchorScroll', anchorScroll);